export const situationMap = {
  FINISHED: { color: '#dcfce7', text: 'FINISHED', keys: ['50320003', 'Pago'] },
  PENDING: { color: '#dbeafe', text: 'PENDING', keys: ['Em Aberto', '50320001'] },
  EXEMPT: { color: '#fef9c3', text: 'EXEMPT', keys: ['Cancelado', '50320002'] },
  EXTENDED: { color: '#fef9c3', text: 'EXTENDED_INVOICE_DOCUMENT', keys: ['Prorrogado', '50320004'] },
  LATE: { color: '#fecaca', text: 'LATE', keys: ['Vencida'] }
}
